import { styled, Typography } from '@mui/material';

export const DialogTitleTypo = styled(Typography)`
    font-size: 42px;
    font-weight: 700;
    line-height: 44px;
    text-align: center;
    text-transform: capitalize;
`;

export const PageNumberTypo = styled(Typography)`
    font-size: 14px;
    font-weight: 500;
    color: #1890ff;
`;

export const DetailedInfoTitleTypo = styled(Typography)`
    font-size: 14px;
    font-weight: 600;
`;

export const DetailedInfoLabelTypo = styled(Typography)`
    font-size: 16px;
    font-weight: 400;
`;
